import React, { useState, useCallback } from 'react';
import { Chart, Series, Legend, ValueAxis,
  Aggregation, AggregationInterval, ArgumentAxis,
  Label, TickInterval, CommonSeriesSettings, Tooltip, } from 'devextreme-react/chart';
import {SIFReportingCompanies, SIFFilter} from '../'
import { groupBy } from '../../utils/miscUtil';

export default function SIFTimeOfEvent(props) {
  const [data, setData] = useState();

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    var fd = groupBy(aggregationInfo.data, 'Time of Event')
    var fd1 = {"Not Specified":0, "(Morning) 6am-12pm":0, "(Afternoon) 12pm-6pm":0,  "(Evening) 6pm-12am":0, "(Overnight) 12am-6am":0}

    for (const [key, value] of Object.entries(fd)) {
      fd1[key] = value.length
    }
    fd1['total']=aggregationInfo.data.length;
    fd1['DATE OF EVENT (m/d/yyyy)'] = aggregationInfo.intervalStart;
    return fd1;
  }, []);

  function customizeText(arg) {
    let q = Math.floor((arg.value.getMonth() + 3) / 3).toString();
    let y = arg.value.getFullYear().toString();
    return `Qtr ${q} ${y}`;
  }

  const onFilterDataChanged = useCallback((data) => {
    setData([...data]);
  }, []);

  const customizeTooltip = useCallback((pointInfo) => {
    let q = Math.floor((pointInfo.argument.getMonth() + 3) / 3).toString();
    let y = pointInfo.argument.getFullYear().toString();
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${`Qtr ${q} ${y}`} - Events: ${pointInfo.total}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].valueText} (${pointInfo.points[i].percentText})</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showPotentialActual={true}
        showCategories={true}
        showTimeOfDay={true}
      />
      <Chart
        id="chart"
        dataSource={data}
        title='Time of Event'
      >
        <ArgumentAxis aggregatedPointsPosition="crossTicks">
          <AggregationInterval quarters={1} />
          <TickInterval quarters={1} />
          <Label customizeText={customizeText}
          />
        </ArgumentAxis>

        <CommonSeriesSettings
          argumentField="DATE OF EVENT (m/d/yyyy)"

        >
          <Aggregation
            enabled={true}
            calculate={calculateCount}
            method="custom"
          />
        </CommonSeriesSettings>

        <Series
          type="stackedbar"
          valueField="Not Specified"
          name="Not Specified"
          color="rgba(0, 0, 0, 0.1)"
        >
        </Series>

        <Series
          type="stackedbar"
          valueField="(Morning) 6am-12pm"
          name="(Morning) 6am-12pm"
          color="rgba(20, 77, 109, 0.4)"
        >
        </Series>
        <Series
          type="stackedbar"
          valueField="(Afternoon) 12pm-6pm"
          name="(Afternoon) 12pm-6pm"
          color="rgba(20, 77, 109, 0.6)"
        >
        </Series>
        <Series
          type="stackedbar"
          valueField="(Evening) 6pm-12am"
          name="(Evening) 6pm-12am"
          color="rgba(20, 77, 109, 0.8)"
        >
        </Series>
        <Series
          type="stackedbar"
          valueField="(Overnight) 12am-6am"
          name="(Overnight) 12am-6am"
          color="rgba(20, 77, 109, 1)"
        >
        </Series>
        { false && <Series
          type="spline"
          valueField="total"
          name="Events"
          color="rgba(237, 78, 32, 1)"
        >
        </Series>}
        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>

      <SIFReportingCompanies data={data}/>

    </div>
  );
}
